(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["magic-announcement-marquee"] && !Shopify.designMode) return;
  try {
    
  class MagicAnnouncementMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.magic-marquee__track');
      if (!this.track) return;

      // Parse speed; floor at 1 px/s so duration calc never divides by zero
      // even if a stale/edited theme setting smuggles in 0.
      const rawSpeed = parseFloat(this.getAttribute('data-speed'));
      this.speed = Math.max(isFinite(rawSpeed) ? rawSpeed : 100, 1);

      // Capture original markup ONCE per element lifetime — NOT on every
      // reconnect. Theme editor drag-drop disconnects+reconnects the live
      // node; if we re-captured here we'd grab the already-duplicated DOM
      // and grow exponentially every move.
      if (!this._originalHTML) {
        this._originalHTML = this.track.innerHTML;
      }

      this._onResize = this._onResize.bind(this);
      this._setup();
      window.addEventListener('resize', this._onResize, { passive: true });

      // Pause the CSS animation when the marquee is scrolled off-screen.
      // Saves CPU + battery on long pages where the user has scrolled
      // way past the header. Resumes automatically on scroll back.
      // Falls back to "always animating" if IntersectionObserver is unavailable.
      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            this.track.style.animationPlayState = entry.isIntersecting ? 'running' : 'paused';
          }
        }, { rootMargin: '50px' });
        this._observer.observe(this);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._onResize);
      if (this._resizeTimer) clearTimeout(this._resizeTimer);
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
    }

    _setup() {
      // Reset track to a single copy of original content
      this.track.classList.remove('is-ready');
      this.track.innerHTML = this._originalHTML;

      // Duplicate until the track is at least 2× viewport so the
      // translateX(0) → translateX(-50%) loop is seamless.
      // SAFETY: 6 doublings caps duplication at 64× original size to
      // protect against pathological "minWidth never reached" inputs.
      const viewport = window.innerWidth || document.documentElement.clientWidth;
      const target = Math.max(viewport * 2, 800);
      let safety = 0;
      while (this.track.scrollWidth < target && safety < 6) {
        this.track.innerHTML += this._originalHTML;
        safety++;
      }
      // Force at least one duplication so the -50% loop point exists
      if (this.track.scrollWidth < viewport * 2) {
        this.track.innerHTML += this._originalHTML;
      }

      // Compute animation duration: travel distance is scrollWidth/2 (we
      // translate to -50%); duration = distance / speed (px/s).
      const duration = (this.track.scrollWidth / 2) / this.speed;
      this.track.style.animationDuration = duration.toFixed(2) + 's';
      requestAnimationFrame(() => this.track.classList.add('is-ready'));
    }

    _onResize() {
      if (this._resizeTimer) clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(() => this._setup(), 200);
    }
  }

  if (!customElements.get('magic-announcement-marquee')) {
    customElements.define('magic-announcement-marquee', MagicAnnouncementMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magic-avisgarantis-stars"] && !Shopify.designMode) return;
  try {
    
  /* Bootstrap AvisGarantis widget once per page. Multiple section instances
     would otherwise load the script multiple times. */
  (function() {
    if (window.__magicAGStarsBoot) return;
    window.__magicAGStarsBoot = true;

    /* Read account ID from the FIRST instance on the page */
    var host = document.querySelector('.magic-ag-stars');
    if (!host) return;
    var siteId = host.getAttribute('data-account-id') || '11040';

    /* AvisGarantis expects a global var, not an init() call */
    window.agSiteId = siteId;

    /* Defer-load the widget JS — non-blocking, runs after parse */
    var existing = document.querySelector('script[src*="JsWidget.js"][data-source="avisgarantis"]');
    if (!existing) {
      var s = document.createElement('script');
      s.src = 'https://www.societe-des-avis-garantis.fr/wp-content/plugins/ag-core/widgets/JsWidget.js';
      s.async = true;
      s.defer = true;
      s.setAttribute('data-source', 'avisgarantis');
      document.head.appendChild(s);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magic-brand-logos"] && !Shopify.designMode) return;
  try {
    
  class MagicLogosMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.magic-logos__track');
      if (!this.track) return;

      // Honour reduced-motion: leave the static (wrap/centered) layout alone.
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }

      // Capture original markup ONCE per element lifetime (theme-editor
      // drag-drop disconnects+reconnects; re-capturing would grab the
      // already-duplicated DOM and grow exponentially).
      if (!this._originalHTML) {
        this._originalHTML = this.track.innerHTML;
      }

      const raw = parseFloat(this.getAttribute('data-speed'));
      this.speed = Math.max(isFinite(raw) ? raw : 40, 5);

      this._onResize = this._onResize.bind(this);
      this._setup();
      window.addEventListener('resize', this._onResize, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._onResize);
      if (this._timer) clearTimeout(this._timer);
    }

    _setup() {
      this.track.classList.remove('is-ready');
      this.track.innerHTML = this._originalHTML;

      // Duplicate until the track is >= 2x viewport so the 0 -> -50% loop is
      // seamless. 6 doublings caps growth at 64x as a safety valve.
      const viewport = window.innerWidth || document.documentElement.clientWidth || 1280;
      let safety = 0;
      while (this.track.scrollWidth < viewport * 2 && safety < 6) {
        this.track.innerHTML += this._originalHTML;
        safety++;
      }
      if (this.track.scrollWidth < viewport * 2) {
        this.track.innerHTML += this._originalHTML;
      }

      const duration = (this.track.scrollWidth / 2) / this.speed;
      this.track.style.animationDuration = duration.toFixed(2) + 's';
      requestAnimationFrame(() => this.track.classList.add('is-ready'));
    }

    _onResize() {
      if (this._timer) clearTimeout(this._timer);
      this._timer = setTimeout(() => this._setup(), 200);
    }
  }

  if (!customElements.get('magic-logos-marquee')) {
    customElements.define('magic-logos-marquee', MagicLogosMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magic-cart-discount-badge"] && !Shopify.designMode) return;
  try {
    
  class MagicCartDiscountBadge extends HTMLElement {
    connectedCallback() {
      this.pct = this.dataset.pct || '5';
      this.emoji = this.dataset.emoji || '🌹';
      this.subscribeText = this.dataset.subscribeText || 'Abonnez-vous dès à présent';
      this.subscribedText = this.dataset.subscribedText || 'Abonnement actif';
      this.subscribedLabel = this.dataset.subscribedLabel || 'ABONNÉ';
      this.tagFilter = (this.dataset.tagFilter || '').toLowerCase().trim();

      // Pass the merchant's colour settings down via CSS vars on <body> so the
      // injected badges (added outside this element's scope) can read them.
      document.body.style.setProperty('--magic-cdb-bg', this.dataset.bg || '#1a1a1a');
      document.body.style.setProperty('--magic-cdb-text', this.dataset.text || '#ffffff');
      document.body.style.setProperty('--magic-cdb-helper', this.dataset.helper || '#666666');

      this._inject();
      // Re-inject on cart updates. Horizon's ThemeEvents fire 'cart:update';
      // we also listen to a couple of aliases other components dispatch.
      this._onCartChange = () => this._inject();
      this._cartEvents = ['cart:update', 'cart:updated', 'cart:refresh'];
      this._cartEvents.forEach(evt => document.addEventListener(evt, this._onCartChange));

      // Watch for DOM changes inside cart-items containers (catches Horizon's
      // re-renders when qty changes etc.)
      this._observer = new MutationObserver(() => {
        // Debounce: re-inject after a short delay
        clearTimeout(this._reinjectTimer);
        this._reinjectTimer = setTimeout(() => this._inject(), 50);
      });
      const containers = document.querySelectorAll('cart-items-component, .cart-items, .cart-drawer__items');
      containers.forEach(c => this._observer.observe(c, {childList: true, subtree: true}));
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
      clearTimeout(this._reinjectTimer);
      if (this._onCartChange && this._cartEvents) {
        this._cartEvents.forEach(evt => document.removeEventListener(evt, this._onCartChange));
      }
    }

    _inject() {
      const rows = document.querySelectorAll('.cart-items__table-row');
      rows.forEach(row => this._injectInto(row));
    }

    _injectInto(row) {
      // Skip if we already injected
      if (row.querySelector('.magic-cdb')) return;
      // Skip nested-line rows (children of bundles)
      if (row.classList.contains('cart-items__nested-line')) return;

      // Two states (Fahad 2026-07-23): a line that is ALREADY a subscription
      // renders the plan name with .magic-subscription-plan. On those rows we
      // show a "subscribed" STATUS badge (so the customer knows this item is
      // under subscription) instead of the "subscribe now" call-to-action —
      // and CSS hides Recurpay's bulky "Changer d'abonnement" box on them.
      const subscribed = !!row.querySelector('.magic-subscription-plan');

      // Tag filter: read from data-product-tags if present
      if (this.tagFilter) {
        const tagsStr = (row.dataset.productTags || row.getAttribute('data-tags') || '').toLowerCase();
        if (!tagsStr.includes(this.tagFilter)) return;
      }

      // Find the qty stepper area to inject next to
      const qtyArea = row.querySelector('.cart-items__qty, [class*="quantity"], [class*="qty"]')
        || row.querySelector('.cart-items__details')
        || row;

      // Build the badge with DOM APIs + textContent (no innerHTML — avoids any
      // markup injection from settings and is CSP-friendly).
      const badge = document.createElement('div');
      badge.className = subscribed ? 'magic-cdb magic-cdb--subscribed' : 'magic-cdb';
      const pill = document.createElement('span');
      pill.className = 'magic-cdb__pill';
      const emojiEl = document.createElement('span');
      emojiEl.className = 'magic-cdb__pill-emoji';
      emojiEl.textContent = subscribed ? '✓' : this.emoji;
      const textEl = document.createElement('span');
      textEl.className = 'magic-cdb__pill-text';
      textEl.textContent = subscribed ? this.subscribedLabel : (this.pct + '% OFF');
      pill.append(emojiEl, textEl);
      const helper = document.createElement('span');
      helper.className = 'magic-cdb__helper';
      helper.textContent = subscribed ? this.subscribedText : this.subscribeText;
      badge.append(pill, helper);

      // Insert after the qty area (or append if no qty area found)
      if (qtyArea.parentElement === row || qtyArea === row) {
        row.appendChild(badge);
      } else {
        qtyArea.parentElement.insertBefore(badge, qtyArea.nextSibling);
      }
    }
  }

  if (!customElements.get('magic-cart-discount-badge')) {
    customElements.define('magic-cart-discount-badge', MagicCartDiscountBadge);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magic-css-overrides"]) return;
  try {
    
  /* Two small post-render tweaks bundled into one IIFE. */
  (function() {
    if (window.__magicOverridesBoot) return;
    window.__magicOverridesBoot = true;

    /* 0. Blog carousel (NOS CONSEILS D'EXPERTS): DESKTOP-ONLY auto-advance every
          3s + pagination dots, driving Horizon's native slideshow API. The phone
          carousel is untouched (dots hidden, no timer). `next()` pages through
          current 0->2->3 (advances by the visible count, clamps to the last),
          so we discover that page sequence and render one dot per stop. */
    var initBlogCarousel = function () {
      var mq = window.matchMedia('(min-width: 750px)');
      var sec = document.querySelector('[id*="featured_blog_ma"]');
      if (!sec) return;
      // The actual scroll container is <slideshow-slides ref="scroller"> (overflow
      // hidden but scrollable). Horizon's native select() mis-scrolls with our
      // fixed-width slides (it jumps current 0->2 without moving), so we drive
      // scrollLeft ourselves: one card-stride per step.
      var scroller = sec.querySelector('slideshow-slides[ref="scroller"]') ||
                     sec.querySelector('slideshow-slides');
      var slides = sec.querySelectorAll('.resource-list__slide');
      if (!scroller || slides.length < 2) {
        return void setTimeout(initBlogCarousel, 300);
      }
      var timer = null, positions = [0], idx = 0, dotsWrap = null, dots = [];

      function computePositions() {
        var r0 = slides[0].getBoundingClientRect();
        var stride = Math.round(slides[1].getBoundingClientRect().left - r0.left);
        if (stride < 50) stride = Math.round(r0.width) + 24;
        var maxScroll = scroller.scrollWidth - scroller.clientWidth;
        if (maxScroll < 10 || stride < 50) return [0];
        var pos = [];
        for (var p = 0; p < maxScroll - 10; p += stride) pos.push(p);
        if (!pos.length || Math.abs(pos[pos.length - 1] - maxScroll) > 12) pos.push(maxScroll);
        return pos;
      }
      function nearestIdx() {
        var sl = scroller.scrollLeft, best = 0, bd = Infinity;
        for (var i = 0; i < positions.length; i++) {
          var d = Math.abs(positions[i] - sl);
          if (d < bd) { bd = d; best = i; }
        }
        return best;
      }
      function paint() {
        for (var i = 0; i < dots.length; i++) {
          dots[i].setAttribute('aria-current', i === idx ? 'true' : 'false');
        }
      }
      function go(i) {
        idx = ((i % positions.length) + positions.length) % positions.length;
        scroller.scrollTo({ left: positions[idx], behavior: 'smooth' });
        paint();
      }
      function tick() { go(idx + 1); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function restart() { stop(); if (mq.matches && positions.length > 1) timer = setInterval(tick, 3000); }

      function build() {
        stop();
        if (dotsWrap) { dotsWrap.remove(); dotsWrap = null; dots = []; }
        if (!mq.matches) return;
        positions = computePositions();
        dotsWrap = document.createElement('div');
        dotsWrap.className = 'magic-blog-dots';
        for (var i = 0; i < positions.length; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Diapositive ' + (i + 1));
          b.setAttribute('aria-current', i === 0 ? 'true' : 'false');
          (function (k) { b.addEventListener('click', function () { go(k); restart(); }); })(i);
          dotsWrap.appendChild(b);
          dots.push(b);
        }
        (sec.querySelector('.section') || sec).appendChild(dotsWrap);
        idx = nearestIdx(); paint(); restart();
      }

      build();
      scroller.addEventListener('mouseenter', stop);
      scroller.addEventListener('mouseleave', restart);
      // keep the active dot in sync if the scroll position changes (arrows / momentum)
      scroller.addEventListener('scroll', function () {
        var n = nearestIdx();
        if (n !== idx) { idx = n; paint(); }
      });
      var rt;
      window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(build, 250); });
    };
    initBlogCarousel();

    /* 1. Strip "[xxx]" suffix from nav labels (e.g. "Diagnostic [diagnostic]"
          → "Diagnostic"). Fixes admin-data typos in nouveau-menu. The right
          long-term fix is editing the menu in Shopify admin.
          Walks ALL elements that match Horizon's various nav label classes —
          desktop mega-menu, drawer menu, and mega-menu links. */
    var cleanNavLabels = function() {
      var spans = document.querySelectorAll(
        '.menu-drawer__menu-item-text, ' +
        '.menu-list__link-title, ' +
        '.menu-list__item-link span, ' +
        '.header__menu-item span, ' +
        '.mega-menu__link span, ' +
        '.header-menu__list-item-name'
      );
      spans.forEach(function(span) {
        if (span.children.length > 0) return;  // only leaf text nodes
        var t = span.textContent;
        if (!t || !/\[/.test(t)) return;
        var cleaned = t.replace(/\s*\[[^\]]+\]\s*$/, '').trim();
        if (cleaned && cleaned !== t.trim()) {
          span.textContent = cleaned;
        }
      });
    };

    /* MutationObserver: catch nav re-renders (theme editor hot reload, drawer
       open/close, etc.) so the cleanup applies again after DOM changes. */
    var attachNavObserver = function() {
      var header = document.querySelector('.header, header-component, header');
      if (!header || header.__navObserverAttached) return;
      header.__navObserverAttached = true;
      var obs = new MutationObserver(function() { cleanNavLabels(); });
      obs.observe(header, { childList: true, subtree: true, characterData: true });
    };

    /* 2. Add comma to French blog dates ("15 mai 2026" → "15 mai, 2026")
          to match live magicafro.fr's date format. Horizon's `time_tag`
          filter uses the locale's format which doesn't include a comma. */
    var commafyDates = function() {
      var dateSpans = document.querySelectorAll(
        '[id*="featured_blog_ma"] .blog-post-details > span:first-child time, ' +
        '[id*="featured_blog_ma"] .blog-post-details > span:first-child'
      );
      dateSpans.forEach(function(el) {
        var t = el.textContent;
        if (!t) return;
        /* Match "15 mai 2026" → "15 mai, 2026". Idempotent (won't re-add). */
        var fixed = t.replace(/(\d{1,2}\s+\w+)\s+(\d{4})\b/, '$1, $2');
        if (fixed !== t) el.textContent = fixed;
      });
    };

    /* Force PDP product-gallery images to load eagerly. Horizon lazy-loads
       them, but the carousel's clipped off-screen slides don't reliably trigger
       lazy-load on scroll → scrolling to those slides shows a BLANK white frame
       (the "wide gap"). Eager-loading the handful of gallery images fixes it
       (matches live, where every slide has its image ready). */
    var eagerGallery = function() {
      /* scoped to the MAIN media container: after the thumbnail rail was added
         (9.8) this selector also matched every thumbnail <img>, including on
         PHONE where the rail is display:none — eager-loading images that are
         never shown. Every image it matched before is inside
         .product-media-container, so current behaviour is unchanged. */
      var imgs = document.querySelectorAll('.product-information media-gallery .product-media-container img');
      imgs.forEach(function(img) {
        /* Setting the loading PROPERTY (not just the attribute) is what actually
           forces a not-yet-loaded lazy image to start fetching immediately. */
        try { img.loading = 'eager'; } catch (e) {}
        img.setAttribute('loading', 'eager');
        if (!img.complete || img.naturalWidth === 0) {
          /* nudge the fetch: re-assigning currentSrc/src (and srcset) reliably
             triggers a load for srcset images too. */
          var ss = img.getAttribute('srcset');
          if (ss) { img.setAttribute('srcset', ss); }
          var s = img.currentSrc || img.getAttribute('src');
          if (s) { img.src = s; }
        }
      });
    };

    var run = function() {
      cleanNavLabels();
      commafyDates();
      attachNavObserver();
      eagerGallery();
    };

    if (document.readyState !== 'loading') run();
    else document.addEventListener('DOMContentLoaded', run);
    /* Catch hot-reload theme-editor re-renders */
    document.addEventListener('shopify:section:load', run);
    /* Also retry once a beat later — Horizon's menu-drawer may render lazily */
    setTimeout(run, 300);
    setTimeout(run, 1500);
  })();

  /* ── Featured-blog carousel AUTOPLAY (phone only). The blog under
        "NOS CONSEILS D'EXPERTS" auto-advances one card every 4.5s so it slides
        on its own (matches live). Pauses for good once the visitor swipes/taps,
        and respects prefers-reduced-motion. Only runs <=749px (desktop shows a
        3-up grid). */
  (function() {
    if (window.__magicBlogAutoplay) return;
    window.__magicBlogAutoplay = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function initBlogAutoplay() {
      if (reduce) return;
      if (!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches)) return;
      var sec = document.querySelector('[id*="featured_blog_ma"]');
      if (!sec) return;
      var scroller = sec.querySelector('slideshow-slides');
      if (!scroller || scroller.dataset.maBlogAutoplay) return;
      var slides = scroller.querySelectorAll(':scope > slideshow-slide');
      if (slides.length < 2) return;
      scroller.dataset.maBlogAutoplay = '1';

      var paused = false;
      ['pointerdown', 'touchstart', 'mousedown', 'keydown'].forEach(function(ev) {
        scroller.addEventListener(ev, function() { paused = true; }, { passive: true });
      });

      var idx = 0;
      setInterval(function() {
        if (paused || document.hidden) return;
        // re-read in case the slideshow re-rendered
        var items = scroller.querySelectorAll(':scope > slideshow-slide');
        if (!items.length) return;
        idx = (idx + 1) % items.length;
        var target = items[idx];
        if (target) {
          scroller.scrollTo({ left: target.offsetLeft - scroller.offsetLeft, behavior: 'smooth' });
        }
      }, 4500);
    }

    if (document.readyState !== 'loading') initBlogAutoplay();
    else document.addEventListener('DOMContentLoaded', initBlogAutoplay);
    window.addEventListener('load', initBlogAutoplay);
    document.addEventListener('shopify:section:load', initBlogAutoplay);
    setTimeout(initBlogAutoplay, 1600);
  })();

  /* FBT relocate (PDP). The Code Black Belt "Frequently Bought Together" widget
     appends itself to <body> (bottom, above the footer). Live places it right
     under the product, so move it to immediately AFTER the main product section
     as soon as it mounts. No-op on non-product pages. */
  (function() {
    if (!document.querySelector('[id*="ProductInformation"]')) return;
    function relocateFBT() {
      var fbt = document.querySelector('.cbb-frequently-bought-container');
      if (!fbt || fbt.parentElement !== document.body) return;
      var pi = document.querySelector('[id*="ProductInformation"]');
      var main = pi && pi.closest('.shopify-section');
      if (main) main.insertAdjacentElement('afterend', fbt);
    }
    var iv = setInterval(relocateFBT, 300);
    setTimeout(function() { clearInterval(iv); }, 15000);
    try {
      var mo = new MutationObserver(relocateFBT);
      mo.observe(document.body, { childList: true });
      setTimeout(function() { mo.disconnect(); }, 15000);
    } catch (e) {}
  })();

  /* FBT layout restructure (PDP, desktop). Live shows the price UNDER each product
     and the accumulated total ON the "Ajouter au panier" button. The CBB widget
     renders name+price in a separate selector-list and the total in the form's own
     price box, so: (1) move the whole form to the END of the container (order =>
     products -> selector-list -> form), and (2) move the total price box INTO the
     add button. CSS (GROUP 8f) then lays the selector-list as 4 columns under the
     images and styles the in-button total. Guards make each move idempotent so the
     scoped observer (for the widget's own re-renders on qty/checkbox change) never
     loops. No-op on non-product pages. */
  (function() {
    if (!document.querySelector('[id*="ProductInformation"]')) return;
    function restructureFBT() {
      var container = document.querySelector('.cbb-frequently-bought-container');
      if (!container) return;
      // 1) form (holds total + add button) to the END => products, selector-list, form
      var form = container.querySelector('.cbb-frequently-bought-form');
      if (form && container.lastElementChild !== form) container.appendChild(form);
      // 2) total price box INTO the add button (appendChild only — never removes the
      //    button's own click handler, so add-to-cart keeps working)
      var btn = container.querySelector('.cbb-frequently-bought-add-button');
      var total = container.querySelector('.cbb-frequently-bought-total-price-box');
      if (btn && total && total.parentElement !== btn) btn.appendChild(total);
    }
    var iv = setInterval(restructureFBT, 400);
    setTimeout(function() { clearInterval(iv); }, 30000);
    try {
      // Persistent, guarded observer on a STABLE ancestor (document.body). The CBB
      // app re-renders by REPLACING .cbb-frequently-bought-container (e.g. on a
      // qty/checkbox change), which would leave a container-scoped observer watching
      // a detached node — so watch the body instead and re-apply. The guards above
      // make every callback a cheap no-op once the layout is already in place, so
      // the appendChild calls never cause a mutation loop.
      var mo = new MutationObserver(function() { restructureFBT(); });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  })();

  /* COLLECTION cards: live shows a full-width "AJOUTER AU PANIER" pill under
     every card (Fahad 2026-07-05) — same injector pattern as the PDP recs
     (Horizon's quick-add overlay is hidden via GROUP 15). Click: first
     available variant -> /cart/add.js -> Horizon cart refresh + drawer. */
  (function() {
    if (!document.querySelector('.collection-wrapper')) return;

    async function refreshCartUICol() {
      try {
        var cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
        var comp = document.querySelector('cart-drawer-component cart-items-component') || document.querySelector('cart-items-component');
        var sid = comp && (comp.getAttribute('data-section-id') || comp.dataset.sectionId);
        var sections = {};
        if (sid) sections = await (await fetch('/?sections=' + encodeURIComponent(sid), { headers: { Accept: 'application/json' } })).json();
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'magic-col-atc', data: { source: 'magic-col-atc', itemCount: cart.item_count, sections: sections } }
        }));
        setTimeout(function() {
          var drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function') drawer.open();
        }, 350);
      } catch (e) { window.location.href = '/cart'; }
    }

    function injectColButtons() {
      document.querySelectorAll('.collection-wrapper .product-grid__item').forEach(function(item) {
        if (item.querySelector('.magic-recs-atc')) return;
        var link = item.querySelector('a[href*="/products/"]');
        if (!link) return;
        var handle = (link.getAttribute('href').match(/\/products\/([^?\/#]+)/) || [])[1];
        if (!handle) return;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'magic-recs-atc';
        btn.textContent = 'Ajouter au panier';
        btn.addEventListener('click', async function() {
          btn.disabled = true;
          try {
            var p = await (await fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })).json();
            // NO unavailable fallback (Fahad 2026-07-24): the old
            // `|| variants[0]` silently added a SOLD-OUT variant to the cart.
            var v = (p.variants || []).find(function(x) { return x.available; });
            if (!v) {
              btn.textContent = 'Épuisé';
              btn.classList.add('is-soldout');
              btn.disabled = true;
              return;
            }
            var r = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: v.id, quantity: 1 })
            });
            if (!r.ok) throw new Error('add failed');
            await refreshCartUICol();
          } catch (e) {
            window.location.href = '/products/' + handle;
          } finally { btn.disabled = false; }
        });
        /* INSIDE the card content, not the li — Horizon pins the li height to
           the card, so a button appended to the li overflowed under the next
           row (only a sliver peeked out). In the content column the ordering
           rules place it last and the grid row grows to fit. */
        var content = item.querySelector('.product-card__content') || item;
        content.appendChild(btn);
      });
    }
    var iv = setInterval(injectColButtons, 600);
    setTimeout(function() { clearInterval(iv); }, 20000);
    try {
      /* permanent: pagination / filtering re-renders the grid at any time */
      var mo = new MutationObserver(injectColButtons);
      var rl = document.querySelector('results-list') || document.querySelector('.collection-wrapper');
      if (rl) mo.observe(rl, { childList: true, subtree: true });
    } catch (e) {}
  })();

  /* COLLECTION mobile toolbar (live phone parity, Fahad 2026-07-05): live shows
     "Affiner" (15px) + a native "Trier par:" select in the toggle row; Horizon
     shows "Filtrer" + a column switcher (hidden via GROUP 15 CSS). Rename the
     toggle text and inject a native sort select cloned from Horizon's hidden
     sorting-filter select; changing it reloads with ?sort_by=. */
  (function() {
    if (!document.querySelector('.collection-wrapper')) return;

    function setupMobileToolbar() {
      var tog = document.querySelector('.facets-toggle');
      if (!tog) return;
      var btn = tog.querySelector('.facets-toggle__button');
      if (btn) {
        btn.childNodes.forEach(function(n) {
          if (n.nodeType === 3 && /filtrer/i.test(n.textContent)) {
            n.textContent = n.textContent.replace(/filtrer/i, 'Affiner');
          }
        });
      }
      if (tog.querySelector('.magic-mobile-sort')) return;
      var src = document.querySelector('select.sorting-filter__select');
      var wrap = document.createElement('div');
      wrap.className = 'magic-mobile-sort';
      var lbl = document.createElement('label');
      lbl.textContent = 'Trier par:';
      lbl.setAttribute('for', 'magic-mobile-sort-select');
      var sel = document.createElement('select');
      sel.id = 'magic-mobile-sort-select';
      var current = new URL(location.href).searchParams.get('sort_by') || (src ? src.value : '');
      var opts = src
        ? Array.prototype.map.call(src.options, function(o) { return [o.value, o.text]; })
        : [['best-selling', 'Meilleures ventes']];
      opts.forEach(function(p) {
        var o = document.createElement('option');
        o.value = p[0];
        o.textContent = p[1];
        if (p[0] === current) o.selected = true;
        sel.appendChild(o);
      });
      sel.addEventListener('change', function() {
        var u = new URL(location.href);
        u.searchParams.set('sort_by', sel.value);
        location.href = u.toString();
      });
      wrap.appendChild(lbl);
      wrap.appendChild(sel);
      tog.appendChild(wrap);
    }
    setupMobileToolbar();
    var iv2 = setInterval(setupMobileToolbar, 800);
    setTimeout(function() { clearInterval(iv2); }, 10000);
  })();

  /* Recurpay subscription widget relocate (PDP). The Recurpay app embed appends
     its "Achat unique / Abonnez-vous" widget at its own anchor; live shows it
     between the 1/6/12 bundle selector and the Scalapay line. Move it there as
     soon as it mounts. Idempotent; no-op on non-product pages. */
  (function() {
    if (!document.querySelector('[id*="ProductInformation"]')) return;
    function relocateRecurpay() {
      var w = document.querySelector('.recurpay-pdp-widget');
      var bundle = document.querySelector('.magic-bundle');
      if (!w || !bundle) return;
      var anchor = bundle.closest('[class*="custom_liquid"], .block') || bundle;
      if (anchor.nextElementSibling === w) return;
      anchor.insertAdjacentElement('afterend', w);
    }
    /* Price format: this theme renders the widget's default "€11.90" while live
       shows French "11,90 €" (format comes from the app's per-theme config).
       Rewrite matching text nodes inside the widget only. Re-applied on widget
       re-renders via the same observer/interval. */
    function frenchifyRecurpayPrices() {
      var w = document.querySelector('.recurpay-pdp-widget');
      if (!w) return;
      var walker = document.createTreeWalker(w, NodeFilter.SHOW_TEXT);
      var n;
      while ((n = walker.nextNode())) {
        if (/€\s?\d/.test(n.nodeValue)) {
          n.nodeValue = n.nodeValue.replace(/€\s?(\d+)\.(\d{2})/g, '$1,$2 €');
        }
      }
    }
    function tick() { relocateRecurpay(); frenchifyRecurpayPrices(); }
    var iv = setInterval(tick, 400);
    setTimeout(function() { clearInterval(iv); }, 20000);
    try {
      /* Permanent observer: the widget re-renders on variant/plan changes at any
         time. Both callbacks are guarded no-ops when nothing changed, and the
         price rewrite mutates characterData only (observer watches childList),
         so it can never loop. */
      var mo = new MutationObserver(tick);
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  })();

  /* "Compléter la routine" cards: live shows a full-width AJOUTER AU PANIER pill
     on every card; Horizon's global quick-add can't be enabled without touching
     the locked homepage cards, so inject a scoped button per card. Click: fetch
     the product's first available variant, add via /cart/add.js, then refresh
     Horizon's cart UI (badge + drawer) like the FBT integration. */
  (function() {
    if (!document.querySelector('[id*="ProductInformation"]')) return;

    async function refreshCartUIRecs() {
      try {
        var cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
        var comp = document.querySelector('cart-drawer-component cart-items-component') || document.querySelector('cart-items-component');
        var sid = comp && (comp.getAttribute('data-section-id') || comp.dataset.sectionId);
        var sections = {};
        if (sid) sections = await (await fetch('/?sections=' + encodeURIComponent(sid), { headers: { Accept: 'application/json' } })).json();
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'magic-recs-atc', data: { source: 'magic-recs-atc', itemCount: cart.item_count, sections: sections } }
        }));
        setTimeout(function() {
          var drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function') drawer.open();
        }, 350);
      } catch (e) { window.location.href = '/cart'; }
    }

    function injectRecsButtons() {
      var recs = document.querySelector('[id*="__product_recommendations"]');
      if (!recs) return;
      recs.querySelectorAll('.resource-list > *').forEach(function(card) {
        if (card.querySelector('.magic-recs-atc')) return;
        if (/skeleton/.test(card.className)) return;
        var link = card.querySelector('a[href*="/products/"]');
        if (!link) return;
        var handle = (link.getAttribute('href').match(/\/products\/([^?\/#]+)/) || [])[1];
        if (!handle) return;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'magic-recs-atc';
        btn.textContent = 'Ajouter au panier';
        btn.addEventListener('click', async function() {
          btn.disabled = true;
          try {
            var p = await (await fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })).json();
            // NO unavailable fallback (Fahad 2026-07-24): the old
            // `|| variants[0]` silently added a SOLD-OUT variant to the cart.
            var v = (p.variants || []).find(function(x) { return x.available; });
            if (!v) {
              btn.textContent = 'Épuisé';
              btn.classList.add('is-soldout');
              btn.disabled = true;
              return;
            }
            var r = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: v.id, quantity: 1 })
            });
            if (!r.ok) throw new Error('add failed');
            await refreshCartUIRecs();
          } catch (e) {
            window.location.href = '/products/' + handle;
          } finally { btn.disabled = false; }
        });
        card.appendChild(btn);
      });
    }
    var iv = setInterval(injectRecsButtons, 600);
    setTimeout(function() { clearInterval(iv); }, 25000);
    try {
      var mo = new MutationObserver(injectRecsButtons);
      var recsSec = document.querySelector('[id*="__product_recommendations"]');
      if (recsSec) mo.observe(recsSec, { childList: true, subtree: true });
    } catch (e) {}
  })();

  /* FBT add-to-cart => refresh Horizon's cart UI (Fahad: "make sure clicking adds
     all these to the cart"). The Code Black Belt widget adds items with its OWN
     /cart/add.js call but never notifies the Horizon theme, so the header cart
     badge + drawer don't refresh and it looks like nothing happened. Here: catch
     the FBT add-button click, poll /cart.js until the cart actually grows, then
     dispatch the theme's native `cart:update` event (which updates the header
     badge via cart-icon and morphs the drawer contents from the freshly rendered
     header section) and slide the cart drawer open for confirmation. We do NOT
     touch the CBB add itself (it works) — only add the missing UI refresh. */
  (function() {
    if (!document.querySelector('[id*="ProductInformation"]')) return;

    async function refreshCartUI() {
      try {
        var cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
        var comp = document.querySelector('cart-drawer-component cart-items-component')
                || document.querySelector('cart-items-component');
        var sid = comp && (comp.getAttribute('data-section-id') || comp.dataset.sectionId);
        var sections = {};
        if (sid) {
          sections = await (await fetch('/?sections=' + encodeURIComponent(sid), { headers: { Accept: 'application/json' } })).json();
        }
        // Horizon's cart:update: cart-icon sets the badge to itemCount (source !=
        // 'product-form-component' => SET, not add), cart-items-component morphs the
        // drawer from data.sections[sectionId].
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'cbb-fbt', data: { source: 'cbb-fbt', itemCount: cart.item_count, sections: sections } }
        }));
        setTimeout(function() {
          var drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function') drawer.open();
        }, 350);
      } catch (e) {
        window.location.href = '/cart'; // fallback: still show the cart
      }
    }

    document.addEventListener('click', function(e) {
      var t = e.target;
      if (!t || !t.closest || !t.closest('.cbb-frequently-bought-add-button')) return;
      // pre-add cart size (header badge is synchronous + reflects the current cart)
      var badge = document.querySelector('#cart-bubble-text, .cart-bubble__text');
      var baseline = badge ? (parseInt((badge.textContent || '').trim(), 10) || 0) : 0;
      var done = false, tries = 0;
      var poll = setInterval(async function() {
        tries++;
        try {
          var c = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
          if (!done && c.item_count > baseline) {
            done = true; clearInterval(poll);
            setTimeout(refreshCartUI, 700); // settle: let all selected items finish adding
          }
        } catch (err) {}
        if (tries > 30) clearInterval(poll); // ~15s cap
      }, 500);
    }, true);
  })();

  /* MOBILE featured-blog dot pager (Fahad 2026-07-06): live shows dots below
     the card, no arrows. Horizon's blog carousel only renders arrows (hidden
     on mobile via GROUP 3 CSS). Build a lightweight dot pager synced to the
     native scroll track — one dot per slide, active follows scroll, click a
     dot to scroll to that card. Phone only. */
  (function () {
    function build() {
      if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;
      var section = document.querySelector('[id*="featured_blog_ma"]');
      if (!section) return;
      var track = section.querySelector('slideshow-slides');
      var slides = section.querySelectorAll('.resource-list__slide');
      if (!track || slides.length < 2) return;
      if (section.querySelector('.magic-blog-dots')) return; // once

      var dots = document.createElement('ul');
      dots.className = 'magic-blog-dots';
      /* inline the layout so it never depends on CSS-bundle timing */
      dots.style.cssText = 'display:flex;justify-content:center;gap:8px;margin:18px 0 0;padding:0;list-style:none;';
      for (var i = 0; i < slides.length; i++) {
        var li = document.createElement('li');
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'magic-blog-dots__dot' + (i === 0 ? ' is-active' : '');
        b.setAttribute('aria-label', 'Article ' + (i + 1));
        b.dataset.idx = i;
        li.appendChild(b);
        dots.appendChild(li);
      }
      // place directly under the carousel
      var carousel = section.querySelector('.resource-list__carousel') || track.closest('.resource-list') || track.parentElement;
      (carousel.parentElement || section).insertBefore(dots, carousel.nextSibling);

      var buttons = dots.querySelectorAll('.magic-blog-dots__dot');
      function step() {
        var r = slides[0].getBoundingClientRect();
        var r1 = slides[1].getBoundingClientRect();
        return Math.abs(r1.left - r.left) || r.width;
      }
      function setActive(idx) {
        for (var i = 0; i < buttons.length; i++) buttons[i].classList.toggle('is-active', i === idx);
      }
      var raf;
      track.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var idx = Math.round(track.scrollLeft / step());
          if (idx < 0) idx = 0;
          if (idx > buttons.length - 1) idx = buttons.length - 1;
          setActive(idx);
        });
      }, { passive: true });
      dots.addEventListener('click', function (e) {
        var b = e.target.closest('.magic-blog-dots__dot');
        if (!b) return;
        var idx = parseInt(b.dataset.idx, 10) || 0;
        track.scrollTo({ left: idx * step(), behavior: 'smooth' });
        setActive(idx);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { setTimeout(build, 400); });
    } else {
      setTimeout(build, 400);
    }
    // retry a few times while the carousel hydrates
    var t = 0, iv = setInterval(function () { build(); if (++t > 15 || document.querySelector('.magic-blog-dots')) clearInterval(iv); }, 500);
  })();

  /* ================================================================
     MAGIC CART MERGE — post-add duplicate-line normalizer (2026-07-22)
     Rapi's app embed patches window.fetch ON PDPs and tags every add
     with hidden props (__rapi_offer/_rapi_bundles/_rapi_market); every
     other surface (drawer recos, wishlist, collection pill, PDP recs
     pill, gift wrapper, CBB FBT) posts BARE bodies. Shopify merges
     lines only on byte-identical properties, so the same variant
     splits into 2+ lines (Fahad's screenshot, 2026-07-22). This
     watches every cart mutation, waits for a quiet network, snapshots
     /cart.js, and collapses "mergeable singles" (bare props OR Rapi's
     single '1 Qté' props) of the same variant with ONE atomic
     /cart/update.js (dupes -> 0, keeper -> summed qty), then re-syncs
     Horizon via its own 'cart:update' bus.
     NEVER touched: Rapi 6/12 offer lines (the tier discount is keyed
     to those props), Recurpay selling_plan lines, gift cards, any
     line with foreign or user-visible properties. Observe-only fetch
     patch: request and response are never read or replaced, so
     Horizon's product-form and Rapi's own patch are untouched in
     either install order. Worst failure mode = today's status quo. */
  (function () {
    if (window.__magicCartMergeBoot) return;
    window.__magicCartMergeBoot = true;

    var RAPI_PROPS = { '__rapi_offer': 1, '_rapi_bundles': 1, '_rapi_market': 1 };
    var MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?([\/?]|$)/;

    var state = {
      inFlight: 0,    // cart-mutating requests on the wire (quiet gate)
      timer: null,    // debounce handle
      running: false, // a pass is executing (mutex)
      current: null,  // promise of the executing pass
      dirty: false,   // trigger arrived mid-pass -> one more pass after
      self: false,    // our own /cart/update.js is being issued
      fails: 0        // consecutive pass failures (retry cap)
    };

    function hasMarker(input, init) {
      try {
        var h = (init && init.headers) ||
                (input && typeof input === 'object' && input.headers) || null;
        if (!h) return false;
        if (typeof h.get === 'function') return !!h.get('X-Magic-Merge');
        return !!(h['X-Magic-Merge'] || h['x-magic-merge']);
      } catch (e) { return false; }
    }

    /* 1. Observe-only fetch patch. Composes with Rapi's PDP patch in
       either install order (each wrapper calls through). The promise
       and response are returned UNTOUCHED. */
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = '';
      try {
        url = typeof input === 'string' ? input : (input && input.url) || String(input || '');
      } catch (e) {}
      var mutating = MUTATION_RE.test(url);
      var mine = mutating && (state.self || hasMarker(input, init));
      if (mutating) state.inFlight++;
      var p;
      try {
        p = origFetch.apply(this, arguments);
      } catch (e) {
        if (mutating) state.inFlight--;
        throw e;
      }
      if (mutating && p && typeof p.then === 'function') {
        p.then(
          function () { state.inFlight--; if (!mine) schedule(false); },
          function () { state.inFlight--; }
        );
      } else if (mutating) {
        state.inFlight--;
      }
      return p;
    };

    /* 2. Event triggers: the theme bus + our legacy custom names
       (gift wrapper's 'cart:updated', wishlist's 'cart:refresh').
       Redundant for fetch-based adds; catches any XHR path that
       announces itself. */
    ['cart:update', 'cart:updated', 'cart:refresh'].forEach(function (name) {
      document.addEventListener(name, function (e) {
        var src = e && e.detail && e.detail.data && e.detail.data.source;
        if (src === 'magic-merge') return; // our own dispatch — never re-trigger
        schedule(false);
      });
    });

    /* 3. Debounced, serialized scheduler. */
    function schedule(quiet) {
      if (state.timer) clearTimeout(state.timer);
      state.timer = setTimeout(function () { kick(quiet); }, 400);
    }
    function kick(quiet) {
      state.timer = null;
      if (state.inFlight > 0) return schedule(quiet); // network not quiet yet
      runPass(quiet);
    }
    function runPass(quiet) {
      if (state.running) { state.dirty = true; return state.current; }
      state.running = true;
      state.current = normalize(quiet).then(
        function () { state.fails = 0; },
        function () { if (++state.fails <= 3) schedule(quiet); }
      ).then(function () {
        state.running = false;
        if (state.dirty) { state.dirty = false; schedule(quiet); }
      });
      return state.current;
    }

    /* On-demand sweep (used by buy-now before the /checkout redirect).
       Resolves when a full pass has completed; quiet = never pops the
       drawer. */
    window.__magicCartMergeNow = function () {
      if (state.timer) { clearTimeout(state.timer); state.timer = null; }
      return runPass(true) || Promise.resolve();
    };

    /* 4. Line classification — fail-safe: when in doubt, DON'T merge. */
    function mergeClass(item) {
      if (item.selling_plan_allocation) return null;    // Recurpay — never touch
      if (item.gift_card) return null;
      var props = item.properties || {};
      var keys = [];
      for (var k in props) {
        if (Object.prototype.hasOwnProperty.call(props, k) &&
            props[k] !== null && props[k] !== '') keys.push(k);
      }
      if (!keys.length) return 'bare';
      for (var i = 0; i < keys.length; i++) {
        if (!RAPI_PROPS[keys[i]]) return null;           // foreign props — never touch
      }
      if (!props['__rapi_offer']) return null;
      try {
        var o = props['__rapi_offer'];
        o = typeof o === 'string' ? JSON.parse(o) : o;
        /* TIGHTENED vs the reviewed design: require the offer label to
           literally start with "1" ('1 Qté' / '1 Qty'); main:true alone
           is NOT trusted, so a 6/12 tier can never be misread as a
           single even if Rapi marks it main. Fail-safe direction. */
        if (o && /^1(\s|$)/.test(String(o.offer || ''))) {
          return 'rapi-single';                          // the '1 Qté' tier
        }
      } catch (e) { /* unparseable -> conservative */ }
      return null;                                       // 6/12 offers etc.
    }

    /* 5. One normalize pass. */
    function normalize(quiet) {
      return window.fetch('/cart.js', {
        headers: { 'Accept': 'application/json' },
        cache: 'no-store',
        credentials: 'same-origin'
      }).then(function (r) {
        if (!r.ok) throw new Error('cart.js ' + r.status);
        return r.json();
      }).then(function (cart) {
        if (!cart || !cart.items || cart.items.length < 2) return;

        var groups = {}; // variant_id -> [{item, idx, cls}]
        cart.items.forEach(function (it, idx) {
          var cls = mergeClass(it);
          if (!cls) return;
          (groups[it.variant_id] = groups[it.variant_id] || [])
            .push({ item: it, idx: idx, cls: cls });
        });

        var updates = {}, any = false;
        Object.keys(groups).forEach(function (vid) {
          var g = groups[vid];
          if (g.length < 2) return;
          // Keeper: prefer the Rapi-tagged single so FUTURE PDP adds merge
          // into it server-side; tie-break on the oldest line (cart.js lists
          // newest first) so the row keeps its position.
          var keeper = g[0];
          for (var j = 1; j < g.length; j++) {
            var a = g[j];
            var rA = a.cls === 'rapi-single' ? 1 : 0;
            var rK = keeper.cls === 'rapi-single' ? 1 : 0;
            if (rA > rK || (rA === rK && a.idx > keeper.idx)) keeper = a;
          }
          var total = 0;
          g.forEach(function (e) { total += e.item.quantity; });
          g.forEach(function (e) { if (e !== keeper) updates[e.item.key] = 0; });
          updates[keeper.item.key] = total;              // line KEYS, never indices
          any = true;
        });
        if (!any) return; // idempotent terminal state — the real loop-breaker

        // Bundled Section Rendering: fresh drawer + /cart HTML in the SAME
        // response -> the dispatch below morphs with zero extra fetches.
        var sids = [];
        document.querySelectorAll('cart-items-component').forEach(function (c) {
          var sid = c.getAttribute('data-section-id');
          if (sid && sids.indexOf(sid) === -1) sids.push(sid);
        });
        var body = { updates: updates };
        if (sids.length) {
          body.sections = sids.join(',');
          body.sections_url = window.location.pathname;
        }

        // Last-instant staleness guard (pre-launch review 2026-07-23): the
        // /cart.js snapshot above took a round-trip — if ANY cart mutation
        // went on the wire meanwhile (e.g. the customer tapped a drawer
        // stepper right after the add), our plan is stale and an absolute
        // update could clobber their change or retarget shifted line
        // numbers. Abort and re-schedule; the next pass re-snapshots.
        if (state.inFlight > 0) { schedule(quiet); return; }

        // ONE atomic request: dupes->0 AND keeper->sum together. Sequential
        // change.js was rejected: bump-first can 422 on tracked inventory,
        // zero-first loses quantity if the second call dies. Here the
        // variant's cart total is invariant.
        state.self = true;
        var p;
        try {
          p = window.fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Magic-Merge': '1'
            },
            body: JSON.stringify(body)
          });
        } finally { state.self = false; }
        return p.then(function (res) {
          if (!res.ok) throw new Error('cart/update ' + res.status);
          return res.json();
        }).then(function (updated) { dispatchCartUpdate(updated, quiet); });
      });
    }

    /* 6. Horizon UI re-sync — the theme's single 'cart:update' bus.
       Contract: detail.data MUST exist (quick-add reads data.didError
       unguarded); data.itemCount MUST be set (cart-icon SETS the
       bubble to `data.itemCount ?? 0`); source must NOT be
       'product-form-component' (that flips the bubble into += mode);
       data.sections[sid] lets every cart-items-component morph
       directly. */
    function dispatchCartUpdate(cart, quiet) {
      var evt = new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'magic-merge',
          data: {
            source: 'magic-merge',
            itemCount: cart.item_count,
            sections: cart.sections || undefined
          }
        }
      });
      // cart-drawer auto-opens on ANY 'cart:update' when the theme setting
      // auto_open_cart_drawer is on — native right after an add, wrong for a
      // silent sweep. dispatchEvent is synchronous, so lift the attribute
      // around the dispatch.
      var lifted = [];
      if (quiet) {
        document.querySelectorAll('cart-drawer-component[auto-open]')
          .forEach(function (d) { d.removeAttribute('auto-open'); lifted.push(d); });
      }
      document.dispatchEvent(evt);
      lifted.forEach(function (d) { d.setAttribute('auto-open', ''); });
    }

    /* 7. Pageload sweep: heals dupes made where no in-page trigger could
       run — buy-now's /checkout redirect racing the cap, adds from
       another tab. */
    function boot() { setTimeout(function () { kick(true); }, 1200); }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  /* ================================================================
     GROUP 26 — OUT-OF-STOCK SYNC for our custom buy buttons
     (Fahad 2026-07-24). Shopify's server accepts a sold-out variant
     on this store (POST /cart/add.js → HTTP 200, verified), and our
     custom buttons are rendered from custom-liquid blocks that
     Horizon does NOT re-render on a variant change. So a Liquid-only
     gate would STICK: pick an in-stock variant and the button would
     stay "Épuisé" forever — a lost sale. This mirrors the native
     add-to-cart button in BOTH directions, every time it changes.

     Source of truth = `[disabled] AND no .add-to-cart-icon`, because
     the icon renders only when can_add_to_cart (server truth) and is
     a child element, so Horizon's morph keeps it accurate; whereas
     `disabled` alone is also used as a ~1s transient quantity-rule
     lock on IN-STOCK products (product-form.js) — keying on it alone
     would wrongly block buyable items.
     ================================================================ */
  (function () {
    if (window.__magicOosBoot) return;
    window.__magicOosBoot = true;

    var OURS = '[data-magic-buynow], [data-mm-add], [data-mm-buy]';

    // Scope lookups: quick-add renders a SECOND copy of the whole product
    // form in a dialog, so a bare document.querySelector can answer about
    // the wrong product.
    function pick(root) {
      var list = root.querySelectorAll('.add-to-cart-button');
      for (var i = 0; i < list.length; i++) {
        var b = list[i];
        if (b.closest('sticky-add-to-cart')) continue;   // Horizon's own sticky copy
        if (b.closest('.magic-mobile-atc')) continue;    // our bar (root class
                                                        // is .magic-mobile-atc,
                                                        // NOT ...-atc-bar)
        return b;
      }
      return null;
    }
    function nativeAtcFor(el) {
      // The sticky mobile bar is its OWN section and contains no native
      // button, so a scoped-only lookup finds nothing and the bar would never
      // sync. It is a PDP-only, single-product surface, so a document-wide
      // lookup is correct there. Everything else stays scoped, because
      // quick-add renders a second product form in a dialog.
      if (el.closest('.magic-mobile-atc')) return pick(document);
      var scope = el.closest('#quick-add-modal-content, dialog, product-information, .shopify-section');
      return scope ? (pick(scope) || null) : pick(document);
    }

    function isSoldOut(atc) {
      return !!atc && atc.disabled === true && !atc.querySelector('.add-to-cart-icon');
    }

    function apply(btn, out) {
      if (btn.__magicOos === out) return;   // idempotent → no observer loop
      btn.__magicOos = out;
      btn.disabled = out;
      btn.classList.toggle('is-soldout', out);
      if (out) btn.setAttribute('aria-disabled', 'true');
      else btn.removeAttribute('aria-disabled');
      // Relabel only plain-text buttons — never clobber one containing an
      // <svg> (the mobile "Acheter maintenant" has an inline sparkle icon).
      var buy = btn.getAttribute('data-label-buy');
      if (buy && !btn.querySelector('svg')) {
        btn.textContent = out ? (btn.getAttribute('data-label-soldout') || 'Épuisé') : buy;
      }
    }

    // Debounce with setTimeout, NOT requestAnimationFrame: rAF is suspended
    // while the document is hidden, so a PDP opened in a BACKGROUND TAB
    // (cmd/ctrl-click from a collection) would never sync and its buy buttons
    // would stay enabled on a sold-out product until the tab got focus.
    // Verified: document.hidden === true ⇒ rAF callback never runs.
    var timer;
    function sync() {
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        var ours = document.querySelectorAll(OURS);
        for (var i = 0; i < ours.length; i++) {
          var btn = ours[i];
          var atc = nativeAtcFor(btn);
          if (!atc) continue;               // undeterminable → keep server state
          apply(btn, isSoldOut(atc));
        }
      }, 50);
    }
    window.__magicSyncAvailability = sync;

    document.addEventListener('variant:update', sync);
    document.addEventListener('variant:selected', sync);

    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        // ignore our own writes
        if (t && t.nodeType === 1 && t.matches && t.matches(OURS)) continue;
        sync();
        return;
      }
    });
    function observe() {
      if (!document.body) return;
      mo.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled'] });
      sync();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe);
    else observe();
    // Horizon hydrates progressively — re-check a few times after load.
    var n = 0, iv = setInterval(function () { sync(); if (++n > 6) clearInterval(iv); }, 500);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magic-gift-wrapper"] && !Shopify.designMode) return;
  try {
    
  class MagicGiftWrapper extends HTMLElement {
    connectedCallback() {
      this.variantId = this.dataset.variantId;
      this.button = this.querySelector('[data-magic-gw-add]');
      this.successLabel = this.dataset.successLabel || '✓ Added';
      if (!this.button || !this.variantId) return;
      this._onClick = this._onClick.bind(this);
      this.button.addEventListener('click', this._onClick);
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this._onClick);
    }

    async _onClick(e) {
      e.preventDefault();
      if (this.classList.contains('is-loading') || this.classList.contains('is-added')) return;
      this.classList.add('is-loading');

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({items: [{id: this.variantId, quantity: 1}]})
        });
        if (!res.ok) throw new Error('add failed');

        this.classList.remove('is-loading');
        this.classList.add('is-added');
        // Replace label with success state
        const label = this.querySelector('.magic-gift-wrapper__label');
        if (label) label.textContent = this.successLabel;
        // Notify the rest of the theme that the cart changed
        document.dispatchEvent(new CustomEvent('cart:updated', {bubbles: true}));
        // Hide the upsell after 1.5s
        setTimeout(() => {
          this.style.display = 'none';
        }, 1500);
      } catch (err) {
        this.classList.remove('is-loading');
        console.warn('Magic gift wrapper add failed:', err);
      }
    }
  }

  if (!customElements.get('magic-gift-wrapper')) {
    customElements.define('magic-gift-wrapper', MagicGiftWrapper);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magic-hero"] && !Shopify.designMode) return;
  try {
    
  class MagicHero extends HTMLElement {
    connectedCallback() {
      if (this._init) return; this._init = true;
      this.track = this.querySelector('.magic-hero__track');
      this.slides = [...this.querySelectorAll('.magic-hero__slide')];
      this.dots = [...this.querySelectorAll('.magic-hero__dot')];
      if (!this.track || this.slides.length < 2) return;
      this.index = 0; this._paused = false;
      this.track.addEventListener('scroll', () => {
        clearTimeout(this._st);
        this._st = setTimeout(() => { this._syncDots(Math.round(this.track.scrollLeft / this.track.clientWidth)); }, 80);
      }, { passive: true });
      this.dots.forEach((d, i) => d.addEventListener('click', () => this.goTo(i)));
      ['pointerdown', 'touchstart', 'mouseenter'].forEach(ev => this.addEventListener(ev, () => { this._paused = true; }, { passive: true }));
      this.addEventListener('mouseleave', () => { this._paused = false; });
      if (this.dataset.autoplay === 'true') {
        const speed = parseInt(this.dataset.speed, 10) || 6000;
        this._timer = setInterval(() => { if (this._paused || document.hidden) return; this.goTo((this.index + 1) % this.slides.length); }, speed);
      }
    }
    _syncDots(i) { if (i < 0 || i >= this.slides.length) return; this.index = i; this.dots.forEach((d, n) => d.classList.toggle('is-active', n === i)); }
    goTo(i) { this.index = i; this.track.scrollTo({ left: this.track.clientWidth * i, behavior: 'smooth' }); this._syncDots(i); }
    disconnectedCallback() { clearInterval(this._timer); }
  }
  if (!customElements.get('magic-hero')) customElements.define('magic-hero', MagicHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magic-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  class MagicNewsletterPopup extends HTMLElement {
    connectedCallback() {
      this.delay = (parseInt(this.dataset.delay, 10) || 5) * 1000;
      this.storageKey = this.dataset.storageKey || 'magic-newsletter-popup';
      this.dialog = this.querySelector('.magic-popup__dialog');
      this.form = this.querySelector('[data-magic-popup-form]');
      this.successEl = this.querySelector('[data-magic-popup-success]');
      this.closeButtons = this.querySelectorAll('[data-magic-popup-close]');
      this.previouslyFocused = null;

      // In the Shopify theme editor, always show (and never persist), so the
      // merchant can preview + style the popup. On the live storefront, skip
      // if the visitor previously dismissed or submitted.
      this._inEditor = !!(window.Shopify && Shopify.designMode);
      if (!this._inEditor) {
        try {
          const state = localStorage.getItem(this.storageKey);
          if (state === 'dismissed' || state === 'submitted') {
            return; // Don't show
          }
        } catch (e) {
          // localStorage may throw in private browsing mode — proceed
        }
      }

      this._onCloseClick = this._onCloseClick.bind(this);
      this._onEsc = this._onEsc.bind(this);
      this._onSubmit = this._onSubmit.bind(this);
      this._onFocusTrap = this._onFocusTrap.bind(this);

      this.closeButtons.forEach(btn => btn.addEventListener('click', this._onCloseClick));
      if (this.form) this.form.addEventListener('submit', this._onSubmit);

      // Delay the open (open promptly in the editor so it's easy to style).
      this.openTimer = setTimeout(() => this.open(), this._inEditor ? 300 : this.delay);
    }

    disconnectedCallback() {
      if (this.openTimer) clearTimeout(this.openTimer);
      this.closeButtons.forEach(btn => btn.removeEventListener('click', this._onCloseClick));
      if (this.form) this.form.removeEventListener('submit', this._onSubmit);
      document.removeEventListener('keydown', this._onEsc);
      document.removeEventListener('keydown', this._onFocusTrap);
      document.body.classList.remove('magic-popup-open');
    }

    open() {
      this.hidden = false;
      this.setAttribute('aria-hidden', 'false');
      this.previouslyFocused = document.activeElement;
      // Force reflow so the transition runs
      void this.offsetWidth;
      this.classList.add('is-open');
      document.body.classList.add('magic-popup-open');
      document.addEventListener('keydown', this._onEsc);
      document.addEventListener('keydown', this._onFocusTrap);
      // Focus the close button by default so screen readers announce the dialog
      const focusable = this.querySelector('.magic-popup__close');
      if (focusable) focusable.focus();
    }

    close(reason) {
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('magic-popup-open');
      document.removeEventListener('keydown', this._onEsc);
      document.removeEventListener('keydown', this._onFocusTrap);

      // Mark dismissed (or submitted) in localStorage — but never in the
      // theme editor, so the popup keeps showing while the merchant styles it.
      try {
        if (!this._inEditor) localStorage.setItem(this.storageKey, reason || 'dismissed');
      } catch (e) { /* private mode */ }

      // Wait for transition before hiding entirely
      setTimeout(() => {
        this.hidden = true;
        if (this.previouslyFocused && typeof this.previouslyFocused.focus === 'function') {
          this.previouslyFocused.focus();
        }
      }, 300);
    }

    _onCloseClick(e) {
      e.preventDefault();
      this.close('dismissed');
    }

    _onEsc(e) {
      if (e.key === 'Escape') {
        this.close('dismissed');
      }
    }

    _onFocusTrap(e) {
      if (e.key !== 'Tab') return;
      const focusables = this.querySelectorAll('button, [href], input, [tabindex]:not([tabindex="-1"])');
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    async _onSubmit(e) {
      // Let the form submit normally via Shopify /contact action,
      // but show success UI first then auto-close after a moment.
      // The submit will reload the page or show Shopify's response — we
      // optimistically close the modal before that to keep UX smooth.

      // Mark submitted in localStorage immediately so we don't show again
      // (skipped in the theme editor so the merchant can keep previewing).
      try {
        if (!this._inEditor) localStorage.setItem(this.storageKey, 'submitted');
      } catch (err) { /* ignore */ }

      // Optimistic success UI
      if (this.successEl && this.form) {
        this.form.style.display = 'none';
        this.successEl.hidden = false;
      }

      // Auto-close after showing the success message
      setTimeout(() => this.close('submitted'), 1500);
      // Do NOT preventDefault — let Shopify capture the submission
    }
  }

  if (!customElements.get('magic-newsletter-popup')) {
    customElements.define('magic-newsletter-popup', MagicNewsletterPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magic-product-arrows"] && !Shopify.designMode) return;
  try {
    
  class MagicProductArrows extends HTMLElement {
    connectedCallback() {
      this._observers = [];
      this.alwaysVisible = this.dataset.alwaysVisible === 'true';
      if (this.alwaysVisible) {
        document.body.classList.add('magic-product-arrows--always');
      }
      this._tryAttach();
      // If product carousels load late (e.g. lazy-loaded), retry once
      this._retryTimer = setTimeout(() => this._tryAttach(), 1500);
    }

    disconnectedCallback() {
      clearTimeout(this._retryTimer);
      this._observers.forEach(o => o.disconnect());
      document.body.classList.remove('magic-product-arrows--always');
    }

    _tryAttach() {
      const sections = document.querySelectorAll('[id*="product_list_"]');
      sections.forEach(section => {
        const carousel = section.querySelector('slideshow-component');
        if (carousel && !carousel.dataset.magicArrowsAttached) {
          this._attach(carousel);
          carousel.dataset.magicArrowsAttached = '1';
        }
      });
    }

    _attach(carousel) {
      const prev = carousel.querySelector('.slideshow-control--previous');
      const next = carousel.querySelector('.slideshow-control--next');
      if (!prev || !next) return;

      // Ensure the carousel is a positioning context for absolute children
      if (getComputedStyle(carousel).position === 'static') {
        carousel.style.position = 'relative';
      }

      const myPrev = this._createArrow('prev', prev);
      const myNext = this._createArrow('next', next);
      carousel.appendChild(myPrev);
      carousel.appendChild(myNext);

      // Mirror native button's [disabled] / [aria-disabled] state to our
      // custom button so it hides at start/end of scroll
      this._mirrorDisabled(prev, myPrev);
      this._mirrorDisabled(next, myNext);
    }

    _createArrow(dir, native) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'magic-product-arrow magic-product-arrow--' + dir;
      btn.setAttribute('aria-label', native.getAttribute('aria-label') || (dir === 'prev' ? 'Previous' : 'Next'));
      btn.innerHTML = dir === 'prev'
        ? '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M12 4l-6 6 6 6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        : '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M8 4l6 6-6 6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        // Re-enable the native button briefly so its handler fires
        native.style.pointerEvents = 'auto';
        native.click();
        // Re-disable so the user can't accidentally tab into it
        requestAnimationFrame(() => { native.style.pointerEvents = 'none'; });
      });
      return btn;
    }

    _mirrorDisabled(native, custom) {
      const sync = () => {
        const disabled = native.disabled || native.getAttribute('aria-disabled') === 'true';
        custom.toggleAttribute('hidden', disabled);
      };
      sync();
      const obs = new MutationObserver(sync);
      obs.observe(native, {attributes: true, attributeFilter: ['disabled', 'aria-disabled']});
      this._observers.push(obs);
    }
  }

  if (!customElements.get('magic-product-arrows')) {
    customElements.define('magic-product-arrows', MagicProductArrows);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magic-product-tabs"] && !Shopify.designMode) return;
  try {
    
  class MagicProductTabs extends HTMLElement {
    connectedCallback() {
      // siblings (the carousels) come AFTER this section in the DOM, so wait
      // until the document has parsed them before wiring up.
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
      } else {
        this.init();
      }
    }

    init() {
      if (this._inited) return;
      this._inited = true;
      this.count = parseInt(this.dataset.count || '0', 10);
      this.tabs = Array.from(this.querySelectorAll('.magic-ptabs__tab'));
      this.viewallWrap = this.querySelector('[data-ptabs-viewall]');
      this.dotsWrap = this.querySelector('[data-ptabs-dots]');
      this.sectionEl = this.closest('.shopify-section') || this;
      this.collectPanels();
      if (!this.panels.length) return; // nothing to control → leave as-is

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(parseInt(tab.dataset.index, 10)));
      });

      const initial = parseInt(this.dataset.initial || '0', 10) || 0;
      this.activate(initial);

      // The product carousel lays out lazily (images/section-rendering), so the
      // scroller width isn't ready at init — rebuild the dots once it settles.
      const refresh = () => this.activate(this.current || 0);
      window.addEventListener('load', refresh, { once: true });
      setTimeout(refresh, 600);
      setTimeout(refresh, 1600);

      if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:section:select', (e) => {
          const idx = this.panels.indexOf(e.target);
          if (idx >= 0) this.activate(idx);
        });
      }
    }

    collectPanels() {
      this.panels = [];
      let node = this.sectionEl.nextElementSibling;
      while (node && this.panels.length < this.count) {
        if (node.classList && node.classList.contains('shopify-section')) {
          this.panels.push(node);
          // hide that carousel's own header (duplicate heading + top-right view-all)
          const header = node.querySelector('.section-resource-list__header');
          if (header) header.style.display = 'none';
        }
        node = node.nextElementSibling;
      }
      // A tab whose collection has no products (e.g. "Déstockage" between sales)
      // is hidden on the storefront, so shoppers never land on an empty row.
      // In the theme editor every tab stays visible so it can still be edited.
      const editing = window.Shopify && window.Shopify.designMode;
      this.empty = this.panels.map((panel) => !panel.querySelector('a[href*="/products/"]'));
      this.tabs.forEach((tab, idx) => {
        if (this.empty[idx] && !editing) {
          tab.hidden = true;
          if (this.panels[idx]) this.panels[idx].style.display = 'none';
        }
      });
      this.fitTabs();
      if (!this._fitBound) {
        this._fitBound = true;
        window.addEventListener('resize', () => this.fitTabs());
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.fitTabs());
      }
    }

    // Phone only: with 2 tabs the headings keep their normal size (and may wrap);
    // with 3 or more they go on one line, at the largest size (max 17px) that fits.
    fitTabs() {
      const nav = this.querySelector('.magic-ptabs__nav');
      const visible = this.tabs.filter((t) => !t.hidden);
      const compact = visible.length >= 3 && window.matchMedia('(max-width: 749px)').matches;
      this.classList.toggle('is-compact', compact);
      visible.forEach((t) => { t.style.fontSize = ''; });
      if (!compact || !nav) return;
      // Measure the labels themselves: a centred flex row that overflows spills
      // into the padding on both sides, which scrollWidth doesn't report.
      const cs = getComputedStyle(nav);
      const room = nav.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      const gaps = parseFloat(cs.columnGap) * (visible.length - 1);
      for (let size = 17; size >= 10; size -= 0.5) {
        visible.forEach((t) => { t.style.fontSize = size + 'px'; });
        const used = visible.reduce((sum, t) => sum + t.getBoundingClientRect().width, 0) + gaps;
        if (used <= room) break;
      }
    }

    activate(i) {
      if (isNaN(i) || i < 0 || i >= this.panels.length) i = 0;
      if (this.tabs[i] && this.tabs[i].hidden) i = Math.max(0, this.tabs.findIndex((t) => !t.hidden));
      this.current = i;
      this.tabs.forEach((tab, idx) => {
        const on = idx === i;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this.panels.forEach((panel, idx) => {
        panel.style.display = idx === i ? '' : 'none';
      });
      const panel = this.panels[i];
      if (!panel) return;
      // Build pagination dots for this carousel, then place dots + view-all
      // below it (order: carousel → dots → view-all), matching live.
      this.buildDots(panel);
      let ref = panel;
      if (this.dotsWrap && this.dotsWrap.style.display !== 'none') {
        panel.after(this.dotsWrap);
        ref = this.dotsWrap;
      }
      if (this.viewallWrap) {
        ref.after(this.viewallWrap);
        const link = this.viewallWrap.querySelector('a');
        const url = this.tabs[i] && this.tabs[i].dataset.viewall;
        if (link && url) link.setAttribute('href', url);
      }
    }

    findScroller(panel) {
      return Array.from(panel.querySelectorAll('*')).find((e) => {
        const cs = getComputedStyle(e);
        return (cs.overflowX === 'auto' || cs.overflowX === 'scroll') && e.scrollWidth > e.clientWidth + 16;
      });
    }

    buildDots(panel) {
      if (!this.dotsWrap) return;
      // The carousel track is <slideshow-slides>; prefer it over generic
      // overflow detection. (findScroller can miss it / it returns a nested one.)
      const scroller = panel.querySelector('slideshow-slides') || this.findScroller(panel);
      // Detach any previous scroll listener before rebuilding.
      if (this._scroller && this._scrollHandler) {
        this._scroller.removeEventListener('scroll', this._scrollHandler);
      }
      // Count ONLY the carousel's DIRECT product slides — NOT the nested per-card
      // image-gallery <slideshow-slide>s (each card has its own gallery, which
      // inflated the count to ~57 and made the dots bail).
      let items = scroller ? Array.from(scroller.querySelectorAll(':scope > slideshow-slide')) : [];
      if (scroller && items.length < 2) {
        items = Array.from(scroller.querySelectorAll('.resource-list__slide'));
      }
      if (!scroller || items.length < 2) {
        this.dotsWrap.style.display = 'none';
        return;
      }
      // ONE dot per scroll position (slide-by-1), matching live magicafro.fr:
      // 13 products with ~2 visible → 12 positions → 1 active dash + 11 circles.
      let stride = items[1].offsetLeft - items[0].offsetLeft;
      if (stride <= 0) stride = items[0].getBoundingClientRect().width || 250;
      const perView = Math.max(1, Math.round(scroller.clientWidth / stride));
      const positions = Math.max(1, items.length - perView + 1);
      if (positions < 2) {
        this.dotsWrap.style.display = 'none';
        return;
      }
      this.dotsWrap.style.display = '';
      this.dotsWrap.textContent = '';
      const dots = [];
      for (let p = 0; p < positions; p++) {
        const target = items[p];
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'magic-ptabs__dot';
        b.setAttribute('aria-label', 'Position ' + (p + 1));
        b.addEventListener('click', () => {
          scroller.scrollTo({ left: target.offsetLeft - scroller.offsetLeft, behavior: 'smooth' });
        });
        this.dotsWrap.appendChild(b);
        dots.push(b);
      }
      const sync = () => {
        const idx = stride > 0 ? Math.round(scroller.scrollLeft / stride) : 0;
        const clamped = Math.max(0, Math.min(idx, dots.length - 1));
        dots.forEach((d, k) => d.classList.toggle('is-active', k === clamped));
      };
      this._scroller = scroller;
      this._scrollHandler = () => {
        cancelAnimationFrame(this._raf);
        this._raf = requestAnimationFrame(sync);
      };
      scroller.addEventListener('scroll', this._scrollHandler, { passive: true });
      sync();
    }
  }

  if (!customElements.get('magic-product-tabs')) {
    customElements.define('magic-product-tabs', MagicProductTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magic-shipping-progress"] && !Shopify.designMode) return;
  try {
    
  /* Keep the free-shipping bar in sync with AJAX cart changes (qty edits on
     the cart page, add-to-cart, etc.). The bar is computed server-side, so on
     a cart change we just re-fetch THIS section via the Section Rendering API
     and swap in the freshly rendered bar — byte-identical markup, updated
     numbers. No client-side math = no risk of visual drift. */
  if (!customElements.get('magic-shipping-progress')) {
    customElements.define('magic-shipping-progress', class extends HTMLElement {
      connectedCallback() {
        this._sid = this.dataset.sectionId;
        this._onChange = this._onChange.bind(this);
        this._events = ['cart:update', 'cart:updated', 'cart:refresh'];
        this._events.forEach((e) => document.addEventListener(e, this._onChange));
      }
      disconnectedCallback() {
        clearTimeout(this._t);
        if (this._events) this._events.forEach((e) => document.removeEventListener(e, this._onChange));
      }
      _onChange() {
        clearTimeout(this._t);
        this._t = setTimeout(() => this._refresh(), 120);
      }
      async _refresh() {
        if (!this._sid) return;
        try {
          const url = window.location.pathname + '?section_id=' + encodeURIComponent(this._sid);
          const res = await fetch(url, { headers: { 'X-Requested-With': 'fetch' } });
          if (!res.ok) return;
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('.magic-sp');
          const current = this.querySelector('.magic-sp');
          if (fresh && current) current.replaceWith(fresh);
        } catch (e) {
          /* network/parse error — leave the existing bar untouched */
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magic-tiktok-videos"] && !Shopify.designMode) return;
  try {
    
  class MagicVideoTile extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.playBtn = this.querySelector('[data-magic-play]');
      if (!this.video || !this.playBtn) return;
      this._mode = 'idle'; // 'idle' | 'preview' (muted hover) | 'full' (clicked, with sound)
      this._onClick = this._onClick.bind(this);
      this._onEnded = this._onEnded.bind(this);
      this.playBtn.addEventListener('click', this._onClick);
      this.video.addEventListener('ended', this._onEnded);

      // Desktop hover-preview: play MUTED on mouse-over, pause + reset on
      // mouse-out. Gated to hover-capable, fine-pointer devices so phones /
      // tablets (tap to play) are unaffected.
      var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (canHover) {
        this._onEnter = this._onEnter.bind(this);
        this._onLeave = this._onLeave.bind(this);
        this.addEventListener('pointerenter', this._onEnter);
        this.addEventListener('pointerleave', this._onLeave);
      }
    }

    disconnectedCallback() {
      if (this.playBtn) this.playBtn.removeEventListener('click', this._onClick);
      if (this.video) this.video.removeEventListener('ended', this._onEnded);
      if (this._onEnter) this.removeEventListener('pointerenter', this._onEnter);
      if (this._onLeave) this.removeEventListener('pointerleave', this._onLeave);
    }

    _onEnter() {
      // Don't interrupt a video the user clicked to watch with sound.
      if (this._mode === 'full') return;
      this._mode = 'preview';
      this.video.muted = true;
      this.classList.add('is-previewing');
      var p = this.video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }

    _onLeave() {
      // Only the muted hover-preview reacts to mouse-out — a full (clicked)
      // play keeps going.
      if (this._mode !== 'preview') return;
      this._mode = 'idle';
      this.classList.remove('is-previewing');
      this.video.pause();
      try { this.video.currentTime = 0; } catch (e) {}
    }

    _onClick(e) {
      e.preventDefault();
      if (!this.video) return;
      // From idle or a muted hover-preview → full play with sound + controls.
      if (this.video.paused || this._mode === 'preview') {
        this._mode = 'full';
        this.video.muted = false;
        this.video.setAttribute('controls', '');
        this.classList.remove('is-previewing');
        this.classList.add('is-playing');
        var self = this;
        var p = this.video.play();
        if (p && typeof p.catch === 'function') {
          p.catch(function () {
            // If autoplay-with-sound is rejected, fall back to muted play.
            self.video.muted = true;
            self.video.play().catch(function () {});
          });
        }
      } else {
        this.video.pause();
        this._mode = 'idle';
        this.classList.remove('is-playing');
      }
    }

    _onEnded() {
      this._mode = 'idle';
      this.classList.remove('is-playing', 'is-previewing');
      this.video.removeAttribute('controls');
    }
  }

  if (!customElements.get('magic-video-tile')) {
    customElements.define('magic-video-tile', MagicVideoTile);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
